module.exports = __webpack_public_path__ + "img/woozy-face.e02590d6.png";